export const removeAiCursor = (llmRequestRefs: any, setMessages: any) => {
    if (!llmRequestRefs.current.aiMessage || !llmRequestRefs.current.aiMessage.message) return;

    const content = llmRequestRefs.current.aiMessage.message.content;
    const updatedContent = [...content];

    if (updatedContent.length === 0) {
        updatedContent.push({type: "text", "text": ''});
    }
    else if (updatedContent[updatedContent.length - 1].type !== "text") {
        return;
    }
    else {
        const lastIndex = updatedContent.length - 1;
        let currentText = updatedContent[lastIndex].text;
        if (currentText[currentText.length - 1] === '●') {
            currentText = currentText.slice(0, -1);
        }

        if (updatedContent[lastIndex].type === "text") {
            updatedContent[lastIndex] = {
                ...updatedContent[lastIndex],
                text: currentText
            };
        }
    }
    llmRequestRefs.current.aiMessage.message = {
        ...llmRequestRefs.current.aiMessage.message,
        content: updatedContent
    };
    setMessages((prev: any) => prev?.deepCopy());
}

export const addTokensToChart = (message: any, updateSessionUsage: any) => {
    try {
        const usageObj: any = {};

        usageObj['model'] = message.model;

        usageObj['input_tokens'] = message.tokens.input_tokens;
        usageObj['output_tokens'] = message.tokens.output_tokens;
        usageObj['input_audio_tokens'] = message.tokens.input_audio_tokens;
        usageObj['output_audio_tokens'] = message.tokens.output_audio_tokens;
        usageObj['reasoning_tokens'] = message.tokens.reasoning_tokens;
        usageObj['cache_creation_input_tokens'] = message.tokens.cache_creation_input_tokens;
        usageObj['cache_read_input_tokens'] = message.tokens.cache_read_input_tokens;
        usageObj['total_tokens'] = message.tokens.total_tokens;

        usageObj['input_charges'] = message.charges.input_charges;
        usageObj['output_charges'] = message.charges.output_charges;
        usageObj['input_audio_charges'] = message.charges.input_audio_charges;
        usageObj['output_audio_charges'] = message.charges.output_audio_charges;
        usageObj['reasoning_charges'] = message.charges.reasoning_charges;
        usageObj['cache_creation_input_charges'] = message.charges.cache_creation_input_charges;
        usageObj['cache_read_input_charges'] = message.charges.cache_read_input_charges;
        usageObj['total_charges'] = message.charges.total_charges;

        updateSessionUsage(usageObj, 'update');
    } catch (e) {}
}
